import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiBaseUrl, getCourseImageUrl } from '../../utils/apiBase';

const categoryColors = {
  1: '#B32025',
  2: '#8b1820',
  3: '#059669',
  4: '#ea580c',
};

const categoryNames = {
  1: 'Business Management',
  2: 'Technology and Programming',
  3: 'Personal Development',
  4: 'Workplace Skills',
};

const FeaturedCourses = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const baseUrl = getApiBaseUrl();
        const response = await axios.get(`${baseUrl}/public/courses`);

        if (response.data?.success) {
          const allCourses = response.data.data || [];
          setCourses(allCourses.slice(0, 3));
        }
      } catch (error) {
        console.error('Error fetching featured courses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Loading courses...</p>
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No courses available at the moment.</p>
      </div>
    );
  }

  return (
    <Row className="g-4">
      {courses.map((course) => (
        <Col lg={4} md={6} key={course.id} className="reveal reveal-up">
          <article
            className="h-100 overflow-hidden bg-white border rounded-4 hover-lift"
            style={{ borderColor: '#e2e8f0' }}
          >
            <div className="position-relative">
              {(course.image || course.course_image) ? (
                <img
                  src={getCourseImageUrl(course.image || course.course_image)}
                  alt={course.name}
                  className="w-100"
                  style={{ height: 200, objectFit: 'cover' }}
                />
              ) : (
                <div
                  className="d-flex align-items-center justify-content-center bg-light"
                  style={{ height: 200 }}
                >
                  <span className="text-muted fs-1">📚</span>
                </div>
              )}

              <span
                className="position-absolute badge rounded-pill px-3 py-2"
                style={{
                  top: 12,
                  right: 12,
                  fontSize: '0.75rem',
                  backgroundColor: categoryColors[course.category_id] || '#64748b',
                }}
              >
                {categoryNames[course.category_id] || 'Uncategorized'}
              </span>
            </div>

            <div className="p-4 d-flex flex-column h-100">
              <h5 className="fw-bold mb-2">{course.name}</h5>
              <p className="text-muted small mb-3 flex-grow-1">
                {course.description?.length > 100
                  ? `${course.description.substring(0, 100)}...`
                  : course.description}
              </p>

              <div className="d-flex justify-content-between align-items-center mb-3 small text-muted">
                <span>
                  <i className="far fa-clock me-1" />
                  {course.duration != null ? `${course.duration} mins` : 'N/A'}
                </span>
                <span>
                  <i className="fas fa-signal me-1" />
                  {course.difficulty_level || 'Beginner'}
                </span>
              </div>

              <button
                type="button"
                className="btn w-100 fw-semibold landing-btn-outline"
                style={{ borderRadius: '999px' }}
                onClick={() => navigate(`/courses/${course.slug || course.id}`)}
              >
                View Details
              </button>
            </div>
          </article>
        </Col>
      ))}
    </Row>
  );
};

export default FeaturedCourses;
